import {BaseModel, attr} from "../../lib/itn-ui-kit/data";

export default class DocumentOptionsModel extends BaseModel {
  static urlPath = 'documents';

  @attr('json') actions;
  @attr('string') description;
  @attr('string') name;
  @attr('json') parses;
  @attr('json') renders;

  get sourceOptions() {
    return this.actions.POST.source.choices;
  }

  get docTypeOptions() {
    return this.actions.POST.document_type.choices;
  }
}
